import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import CheckboxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const VideoCreativeProfile = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Video Creative Profile"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Video Creative Profile']}
				description="Manage Video Creative Profile Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginTop: '2rem', marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={4}>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						containerStyles={{ marginTop: '4rem', width: 'fit-content' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={4}>
					<InputConfig
						label="Profile Name"
						keyData={keyData + '.profileName'}
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={!!rawConfig[keyData + '.enabled']}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default VideoCreativeProfile;
